let Vue = window.Vue;

Vue.component('geetest-verification', {
    template: `
        <div class="geetest-verification">
            <slot :loading="loading"
                :verify="verify"
                :reset="reset"></slot>
        </div>
    `,
    props: {
        authUrl: {
            type: String,
            required: true
        },
        params: Object
    },
    data () {
        return {
            loading: false,
            captcha: null
        };
    },
    methods: {
        verify (resolve) {
            if (this.captcha) {
                this.captcha.verify();
            } else {
                this.loading = true;
                window.axios({
                    url: this.authUrl,
                    method: 'post',
                    data: window.Qs.stringify(Object.assign({}, this.params))
                }).then(response => {
                    let data = response.data;
                    if (data) {
                        let initGeetest = window.initGeetest;
                        if (typeof initGeetest === 'function') {
                            initGeetest({
                                'gt': data['gt'],
                                'challenge': data['challenge'],
                                'offline': !data.success,
                                'new_captcha': data['new_captcha'],
                                'product': 'bind',
                                onError: () => {
                                    this.$message.warning('验证数据获取失败');
                                    this.loading = false;
                                }
                            }, (captcha) => {
                                captcha.onSuccess(() => {
                                    if (typeof resolve === 'function') {
                                        resolve(captcha.getValidate());
                                    }
                                });
                                captcha.onReady(() => {
                                    this.loading = false;
                                    this.$nextTick(() => {
                                        captcha.verify();
                                    });
                                });
                                this.captcha = captcha;
                            });
                        }
                    }
                }, () => {
                    this.$message.warning('验证数据加载失败');
                    this.loading = false;
                });
            }
        },
        reset () {
            let captcha = this.captcha;
            if (captcha) {
                captcha.reset();
                this.captcha = null;
            }
        }
    }
});
new Vue({
    el: '#homePage',
    data () {
        return {
            pageData: window.pageData(),
            platformData: window.platformData(),
            currentTab: 1,
            placeholder: '输入手机号',
            codeVal: '获取验证码',
            mobilePhone: '',
            smscode: '',
            password: '',
            loginId: '',
            disableLogin: true,
            verificationCode: {
                delaySec: 0
            },
            regMobilePhone: '',
            regSmscode: '',
            regPassword: '',
            regAccount: '',
            committing: false,
            disableRegist: true,
            getMobilePhone: '',
            getSmscode: '',
            disableForget: true,
            confirmPassword: '',
            getPassword: '',
            showPwd: false,
            accountId: '', // 重置密码accountId
            findPwdToken: '',
            disableConfirm: true,
            timer: null,
            updateAccount: false,
            updatePhone: false,
            registrationAgreement: false,
            privacyAgreement: false,
            userAccount: '',
            ssoUserIdStr: '',
            loginToken: '',
            loading: false,
            agreementChecked: false,
            nationProjectTokenCache: '',
            courseId: ''
        };
    },
    mixins: [window.globalMixin, window.utilsMixin],
    created() {
        // 从URL参数中获取nationProjectTokenCache
        this.nationProjectTokenCache = this.getUrlParameter('nationProjectTokenCache') || '';
        this.courseId = this.getUrlParameter('courseId') || '';
    },
    watch: {
        mobilePhone (val) {
           if (val && this.smscode !=='') {
                this.disableLogin = false;
           } else {
               this.disableLogin = true;
           }
        },
        smscode (val) {
            if (val && this.mobilePhone !=='') {
                this.disableLogin = false;
            } else {
                this.disableLogin = true;
            }
        },
        loginId (val) {
            if (val && this.password !=='') {
                this.disableLogin = false;
            } else {
                this.disableLogin = true;
            }
        },
        password (val) {
            if (val && this.loginId !=='') {
                this.disableLogin = false;
            } else {
                this.disableLogin = true;
            }
        },
        regMobilePhone (val) {
            if (val && this.regSmscode !=='' && this.regPassword !== '' && this.regAccount !== '') {
                 this.disableRegist= false;
            } else {
                this.disableRegist = true;
            }
         },
         regSmscode (val) {
             if (val && this.regMobilePhone !=='' && this.regPassword !=='' && this.regAccount !== '') {
                 this.disableRegist = false;
             } else {
                 this.disableRegist = true;
             }
         },
         regPassword (val) {
             if (val && this.regSmscode !=='' && this.regMobilePhone !=='' && this.regAccount !== '') {
                 this.disableRegist = false;
             } else {
                 this.disableRegist = true;
             }
         },
        regAccount (val) {
            if (val && this.regSmscode !=='' && this.regMobilePhone !=='' && this.regPassword !== '') {
                this.disableRegist = false;
            } else {
                this.disableRegist = true;
            }
        },
        getMobilePhone (val) {
            if (val && this.getSmscode !=='') {
                this.disableForget = false;
            } else {
                this.disableForget = true;
            }
        },
        getSmscode (val) {
            if (val && this.getMobilePhone !=='') {
                this.disableForget = false;
            } else {
                this.disableForget = true;
            }
        },
        getPassword (val) {
            if (val && this.confirmPassword !=='') {
                this.disableConfirm = false;
            } else {
                this.disableConfirm = true;
            }
        },
        confirmPassword (val) {
            if (val && this.getPassword !=='') {
                this.disableConfirm = false;
            } else {
                this.disableConfirm = true;
            }
        },
    },
    methods: {
        changeLogin (val) {
            this.currentTab = val;
            this.mobilePhone = '';
            this.smscode = '';
            this.password = '';
            this.startDelay(0);
            if (val === 2) {
               this.placeholder = '输入账号、手机号';
            } else {
                this.placeholder = '输入手机号';
            }
        },
        // 倒计时
        startDelay (sec) {
            this.verificationCode.delaySec = sec;
            if (sec > 0) {
                this.timer = setTimeout(() => {
                    this.startDelay(sec - 1);
                }, 1000);
            } else {
                clearTimeout(this.timer);
                this.verificationCode.delaySec = 0;
            }
        },
        // 登录发送验证码
        sendSmsCode (verify, reset) {
            let that = this;
            if (!this.mobilePhone) {
                this.$message.warning('请输入手机号');
                return;
            }
            if (!this.isMobilePhone(this.mobilePhone)) {
                this.$message.warning('输入的手机号不合法');
                return;
            }
            verify(params => {
                window.axios({
                    url: '/index/sms/send/quickLogin',
                    method: 'post',
                    data: window.Qs.stringify(Object.assign({
                        mobilePhone: this.mobilePhone
                    }, params))
                }).then(response => {
                    let data = response.data;
                    if (data.errorCode === 0) {
                        that.startDelay(data.codeTime || 30);
                        this.$message.success(data.message || '验证码发送成功');
                    } else {
                        this.$message.warning(data.message || '验证码发送失败');
                        reset();
                    }
                }, () => {
                    this.$message.warning('验证码发送失败');
                });
            });
        },
        // 绑定手机号发送验证码
        bindPhoneSmsCode (verify, reset) {
            let that = this;
            if (!this.mobilePhone) {
                this.$message.warning('请输入手机号');
                return;
            }
            if (!this.isMobilePhone(this.mobilePhone)) {
                this.$message.warning('输入的手机号不合法');
                return;
            }
            verify(params => {
                window.axios({
                    url: '/index/sms/send/bindPhone',
                    method: 'post',
                    data: window.Qs.stringify(Object.assign({
                        mobilePhone: this.mobilePhone
                    }, params))
                }).then(response => {
                    let data = response.data;
                    if (data.errorCode === 0) {
                        that.startDelay(that.codeTime);
                        this.$message.success(data.message || '验证码发送成功');
                    } else {
                        this.$message.warning(data.message || '验证码发送失败');
                        reset();
                    }
                }, () => {
                    this.$message.warning('验证码发送失败');
                });
            });
        },
        // 注册发送验证码
        sendRegisterSmsCode (verify, reset) {
            if (!this.regMobilePhone) {
                this.$message.warning('请输入手机号');
                return;
            }
            if (!this.isMobilePhone(this.regMobilePhone)) {
                this.$message.warning('输入的手机号不合法');
                return;
            }
            verify(params => {
                window.axios({
                    url: '/index/sms/send/register',
                    method: 'post',
                    data: window.Qs.stringify(Object.assign({
                        mobilePhone: this.regMobilePhone
                    }, params))
                }).then(response => {
                    let data = response.data;
                    if (data.errorCode === 0) {
                        this.$message.success(data.message || '验证码发送成功');
                        this.startDelay(this.codeTime);
                    } else {
                        this.$message.warning(data.message || '验证码发送失败');
                        reset();
                    }
                }, () => {
                    this.$message.warning('验证码发送失败');
                });
            });
        },
        // 找回密码发送验证码
        sendForgetSmsCode (verify, reset) {
            if (!this.getMobilePhone) {
                this.$message.warning('请输入手机号');
                return;
            }
            if (!this.isMobilePhone(this.getMobilePhone)) {
                this.$message.warning('输入的手机号不合法');
                return;
            }
            verify(params => {
                window.axios({
                    url: '/index/sms/send/forgetPwd',
                    method: 'post',
                    data: window.Qs.stringify(Object.assign({
                        mobilePhone: this.getMobilePhone
                    }, params))
                }).then(response => {
                    let data = response.data;
                    if (data.errorCode === 0) {
                        this.$message.success(data.message || '验证码发送成功');
                        this.startDelay(this.codeTime);
                    } else {
                        this.$message.warning(data.message || '验证码发送失败');
                        reset();
                    }
                }, () => {
                    this.$message.warning('验证码发送失败');
                });
            });
        },
        // 立即登录(验证码和密码登录)
        startLogin (verify, reset) {
            if (this.currentTab === 1) {
                let params = {
                    mobilePhone: this.mobilePhone,
                    smsCode: this.smscode
                };
                if (this.nationProjectTokenCache) {
                    params.nationProjectTokenCache = this.nationProjectTokenCache;
                }
                window.axios({
                    url: '/index/userSmsLogin',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Accept': 'text/html, */*',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    method: 'post',
                    data: window.Qs.stringify(params)
                }).then(response => {
                    let data = response.data;
                    if (data.errorCode === 0) {
                        if (this.courseId) {
                            this.toUrl('/learning/courseDetail?courseId=' + this.courseId);
                        } else {
                            this.toUrl('/learning/home');
                        }
                    } else if (data.error && data.error === '1') {
                        // 绑定账户
                        this.updateAccount = true;
                    } else {
                        this.$message.warning(data.message || '用户登录失败');
                    }
                }, () => {
                    this.$message.warning('登录信息发送失败');
                }).finally(() => {
                    this.committing = false;
                });
            } else if (this.currentTab === 2) {
                verify(params => {
                    this.committing = true;
                    let dataPayload = {
                        loginId: this.loginId,
                        password: this.$md5(this.password)
                    };
                    if (this.nationProjectTokenCache) {
                        dataPayload.nationProjectTokenCache = this.nationProjectTokenCache;
                    }
                    // 合并极验参数
                    Object.assign(dataPayload, params);

                    window.axios({
                        url: '/index/userLogin',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Accept': 'text/html, */*',
                            'X-Requested-With': 'XMLHttpRequest'
                        },
                        method: 'post',
                        data: window.Qs.stringify(dataPayload) // 使用包含nationProjectTokenCache的dataPayload
                    }).then(response => {
                        let data = response.data;
                        if (data.errorCode === 0) {
                            if (this.courseId) {
                                this.toUrl('/learning/courseDetail?courseId=' + this.courseId);
                            } else {
                                this.toUrl('/learning/home');
                            }
                        } else if (data.error && data.error === '1') {
                            // 绑定账户
                            this.updateAccount = true;
                        } else if (data.error && data.error === '2') {
                            // 绑定手机号
                            this.updatePhone = true;
                        } else {
                            this.$message.warning(data.message || '用户登录失败');
                            reset();
                        }
                    }, () => {
                        this.$message.warning('登录信息发送失败');
                    }).finally(() => {
                        this.committing = false;
                    });
                });
            }
        },
        // 用户注册
        startRegister (verify, reset) {
            this.committing = true;
            if (!this.isAccount(this.regAccount)) {
                this.$message.warning('输入的账号不合法');
                return;
            }
            if (!this.isComplexPassword(this.regPassword)) {
                this.$message.warning('输入的密码不合法');
                return;
            }
            if (!this.agreementChecked && this.infoConfig.registrationAgreement && this.infoConfig.privacyAgreement) {
                this.$message.warning('请阅读并同意注册协议和隐私政策');
                return;
            } else if (!this.agreementChecked && this.infoConfig.registrationAgreement) {
                this.$message.warning('请阅读并同意注册协议');
                return;
            } else if (!this.agreementChecked && this.infoConfig.privacyAgreement) {
                this.$message.warning('请阅读并同意隐私政策');
                return;
            }
            let params = {
                account: this.regAccount,
                mobilePhone: this.regMobilePhone,
                password: this.$md5(this.regPassword),
                smsCode: this.regSmscode
            };
            if (this.nationProjectTokenCache) {
                params.nationProjectTokenCache = this.nationProjectTokenCache;
            }
            window.axios({
                url: '/index/account/sendRegister',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'text/html, */*',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                method: 'post',
                data: window.Qs.stringify(params)
            }).then(response => {
                let data = response.data;
                if (data) {
                    if (data.errorCode === 0) {
                        this.$message({
                            message: data.message || '用户注册成功',
                            type: 'success',
                            duration: 1000,
                            onClose: () => {
                                if (this.courseId) {
                                    this.toUrl('/learning/courseDetail?courseId=' + this.courseId);
                                } else {
                                    this.toUrl('/learning/home');
                                }
                            }
                        });
                    } else {
                        this.$message.warning(data.message || '用户注册失败');
                    }
                }
            }, () => {
                this.$message.warning('注册信息发送失败');
            }).finally(() => {
                this.committing = false;
            });
        },
        // 绑定账户
        tokenLogin () {
            if (this.loading) {
                return;
            }
            this.loading = true;
            let params;
            if (this.currentTab === 1) {
                params = {
                    mobilePhone: this.mobilePhone,
                    smsCode: this.smscode,
                    account: this.userAccount
                };
                if (this.nationProjectTokenCache) {
                    params.nationProjectTokenCache = this.nationProjectTokenCache;
                }
                window.axios({
                    url: '/index/userSmsLogin',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Accept': 'text/html, */*',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    method: 'post',
                    data: window.Qs.stringify(params)
                }).then(response => {
                    let data = response.data;
                    if (data.errorCode === 0) {
                        if (this.courseId) {
                            this.toUrl('/learning/courseDetail?courseId=' + this.courseId);
                        } else {
                            this.toUrl('/learning/home');
                        }
                    } else if (data.error && data.error === '1') {
                        // 绑定账户
                        this.updateAccount = true;
                    } else {
                        this.$message.warning(data.message || '用户登录失败');
                    }
                }, () => {
                    this.$message.warning('登录信息发送失败');
                }).finally(() => {
                    this.loading = false;
                });
            } else if (this.currentTab === 2) {
                params = {
                    loginId: this.loginId,
                    password: this.$md5(this.password),
                    account: this.userAccount
                };
                if (this.nationProjectTokenCache) {
                    params.nationProjectTokenCache = this.nationProjectTokenCache;
                }
                window.axios({
                    url: '/index/userLogin',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Accept': 'text/html, */*',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    method: 'post',
                    data: window.Qs.stringify(Object.assign({
                        loginId: this.loginId,
                        password: this.$md5(this.password)
                    }, params))
                }).then(response => {
                    let data = response.data;
                    if (data.errorCode === 0) {
                        if (this.courseId) {
                            this.toUrl('/learning/courseDetail?courseId=' + this.courseId);
                        } else {
                            this.toUrl('/learning/home');
                        }
                    } else if (data.error && data.error === '1') {
                        // 绑定账户
                        this.updateAccount = true;
                    } else if (data.error && data.error === '2') {
                        // 绑定手机号
                        this.updatePhone = true;
                    } else {
                        this.$message.warning(data.message || '用户登录失败');
                    }
                }, () => {
                    this.$message.warning('登录信息发送失败');
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        // 绑定手机号
        bindPhone () {
            if (this.loading) {
                return;
            }
            if (!this.mobilePhone) {
                this.$message.warning('请输入手机号');
                return;
            }
            if (!this.isMobilePhone(this.mobilePhone)) {
                this.$message.warning('输入的手机号不合法');
                return;
            }
            if (!this.smscode) {
                this.$message.warning('请输入验证码');
                return;
            }
            this.loading = true;
            let other = {
                mobilePhone: this.mobilePhone,
                smsCode: this.smscode
            };
            let params = {
                loginId: this.loginId,
                password: this.$md5(this.password),
                other: JSON.stringify(other)
            };
            if (this.nationProjectTokenCache) {
                params.nationProjectTokenCache = this.nationProjectTokenCache;
            }
            window.axios({
                url: '/index/userLogin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'text/html, */*',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                method: 'post',
                data: window.Qs.stringify(params)
            }).then(response => {
                let data = response.data;
                if (data.errorCode === 0) {
                    if (this.courseId) {
                        this.toUrl('/learning/courseDetail?courseId=' + this.courseId);
                    } else {
                        this.toUrl('/learning/home');
                    }
                } else if (data.error && data.error === '1') {
                    // 绑定账户
                    this.updateAccount = true;
                } else if (data.error && data.error === '2') {
                    // 绑定手机号
                    this.updatePhone = true;
                } else {
                    this.$message.warning(data.message || '用户登录失败');
                }
            }, () => {
                this.$message.warning('登录信息发送失败');
            }).finally(() => {
                this.loading = false;
            });
        },
        // 去注册
        toRegister () {
            this.mobilePhone = '';
            this.smscode = '';
            this.password = '';
            this.currentTab = 3;
        },
        // 切换登录方式
        toLogin () {
            this.currentTab = 1;
        },
        // 忘记密码
        forgetPassword () {
            this.currentTab = 4;
        },
        // 开始重置
        requestReset () {
            this.committing = true;
            window.axios({
                url: '/index/account/resetPwd',
                method: 'post',
                data: window.Qs.stringify({
                    mobilePhone: this.getMobilePhone,
                    smsCode: this.getSmscode
                })
            }).then(response => {
                let data = response.data;
                if (data) {
                    if (data.errorCode === 0) {
                        this.showPwd = true;
                        this.findPwdToken = data.token || '';
                        this.accountId = data.accountId || '';
                    } else {
                        this.$message.warning(data.message || '找回密码失败');
                    }
                }
            }, () => {
                this.$message.warning('找回密码请求失败');
            }).finally(() => {
                this.committing = false;
            });
        },
        // 重置密码
        startReset () {
            if (!this.isComplexPassword(this.getPassword)) {
                this.$message.warning('输入的密码不合法');
                return;
            }
            if (this.confirmPassword !== this.getPassword) {
                this.$message.warning('两次输入密码不一致');
                return;
            }
            this.committing = true;
            window.axios({
                url: '/index/account/submitResetPwd',
                method: 'post',
                data: window.Qs.stringify({
                    accountId: this.accountId || '',
                    token: this.findPwdToken || '',
                    password: this.$md5(this.getPassword)
                })
            }).then(response => {
                let data = response.data;
                if (data) {
                    if (data.errorCode === 0) {
                        this.$message.success(data.message || '重置密码成功');
                       this.currentTab = 2;
                        this.$nextTick(() => {
                            this.findPwdToken = '';
                            this.accountId = '';
                        });
                    } else {
                        this.$message.warning(data.message || '重置密码失败');
                    }
                }
            }, () => {
                this.$message.warning('重置密码请求失败');
            }).finally(() => {
                this.committing = false;
            });
        },
        // 扫码登录
        qrCodeLogin () {
            window.location.href = '/index/account/verifyUserLogin?path=' + encodeURIComponent(encodeURIComponent('/learning/home'))  + '&type=1';
        },
        // 获取URL参数
        getUrlParameter(name) {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get(name);
        }
    }
});
